const displaynextatd = (state = [], action) => {
  switch (action.type) {
    case "TOGGLE_VISIBLE":
      return {
        type: "TOGGLE_VISIBLE",
        displaynextatd: action.displaynextatd,
        displaynextatdtemp: action.displaynextatdtemp,
      };
    default:
      return state;
  }
};

export default displaynextatd;
